import api from './api';
import { Folder } from '../types';

export const foldersService = {
  // Get all folders
  async getAll(): Promise<Folder[]> {
    const response = await api.get('/folders');
    return response.data;
  },

  // Get folder by ID with documents
  async getById(id: string): Promise<Folder> {
    const response = await api.get(`/folders/${id}`);
    return response.data;
  },

  // Create folder
  async create(data: { name: string; description?: string }): Promise<Folder> {
    const response = await api.post('/folders', data);
    return response.data;
  },

  // Update folder
  async update(id: string, data: Partial<Folder>): Promise<Folder> {
    const response = await api.patch(`/folders/${id}`, data);
    return response.data;
  },

  // Delete folder
  async delete(id: string): Promise<void> {
    await api.delete(`/folders/${id}`);
  },
};
